import axios from 'axios';
import { User, UserPreferences, Workspace } from '../models/common-types';
import { defaultPreferences, PLATFORM_APP } from '../constants/constants';
import { isSuccess } from '../utils/communication';

interface DeleteUserResponse {
    failure: string[];
    successful: [];
}

const baseUrl = '/api/osint/users';

export interface AuthenticationApi {
    logout: () => Promise<any>;
    getUserDetails: () => Promise<any>;
    getRefreshToken: () => Promise<any>;
    getUsers: () => Promise<User[]>;
    deleteUsers: (userIds: string[]) => Promise<DeleteUserResponse>;
    createUser: (userToCreate: any) => Promise<any>;
    GetUserAssignedWorkspaces: (userId: string) => Promise<Workspace[]>;
}

export class AuthenticationAPI implements AuthenticationApi {
    async updateUserPreferences(preferences: any) {
        try {
            const { data } = await axios.put(`${baseUrl}/preferences`, preferences);

            return data;
        } catch (error) {
            return null;
        }
    }

    async deleteUsers(userIds: string[]) {
        try {
            const { data } = await axios.delete<User[]>(baseUrl, { data: userIds });

            return data;
        } catch (error) {
            return error;
        }
    }

    async getUsers() {
        try {
            const { data } = await axios.get<User[]>(baseUrl);

            return data;
        } catch (error) {
            return error;
        }
    }

    async getUserPreferences(): Promise<UserPreferences> {
        try {
            const { data } = await axios.get<UserPreferences>(`${baseUrl}/preferences`);

            return data;
        } catch (error) {
            return defaultPreferences;
        }
    }

    async getRefreshToken() {
        const response = await axios.post('/api/authentication/token');

        if (response.data.response === 302) {
            window.location.replace(response.headers.Location);
        }
        if (!isSuccess(response)) {
            console.log('refresh token failed');
            this.logout();
        }

        return response.data;
    }

    async logout() {
        if (PLATFORM_APP) {
            window.location.replace('/logout');
        } else {
            await axios.post('/api/authentication/logout', {});
            window.location.replace(`/api/authentication/login?callback=${process.env.PUBLIC_URL}`);
        }
    }

    async getUserDetails() {
        try {
            const { data } = await axios.get(`${baseUrl}/details`);
            return data;
        } catch (error) {
            console.log(error);
            this.logout();
        }
    }

    async GetUserAssignedWorkspaces(userId: string): Promise<Workspace[]> {
        try {
            const { data } = await axios.get<Workspace[]>(`${baseUrl}/${userId}/workspaces`);
            return data;
        } catch (error) {
            return error;
        }
    }

    async createUser(userToCreate) {
        const response = await axios.post<User>(baseUrl, userToCreate);
        return response;
    }

    async updateUser(userId: string, userToUpdateRequestBody: any) {
        const response = await axios.put<User>(`${baseUrl}/${userId}`, userToUpdateRequestBody);
        return response;
    }
}
